import * as React from 'react';
import { Route } from 'react-router-dom';
import CostSummaryPage from '../components/CostSummary/CostSummaryPage';

export default [<Route exact path="/costs" component={CostSummaryPage} />];
